import { useState, useEffect } from "react";
import { projectAuth } from "../firebase/config";
import { useAuthContext } from "./useAuthContext";
import {
  createUserWithEmailAndPassword,
  updateProfile,
  sendEmailVerification,
} from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { db } from "../firebase/config";
import { doc, setDoc } from "firebase/firestore";
import { queryProvision, ssoProviderIdOf } from "../firebase/provision";
import { useSsoLookup } from "./useSsoLookup";

export const useSignup = () => {
  const [isCancelled, setIsCancelled] = useState(false);
  const [error, setError] = useState(null);
  const [isPending, setIsPending] = useState(false);
  const navigate = useNavigate();
  const { dispatch } = useAuthContext();
  const { ssoProviderId, setSsoProviderId, checkEmail } = useSsoLookup();
  const actionCodeSettings = {
    url: "https://www.numetrics.org/ctelink/",
  };
  const signup = async (email, password, displayName, firstName, lastName) => {
    setError(null);
    // setIsPending(true)

    try {
      const defaultSettings = [];
      const querySnap = await queryProvision(email);

      if (querySnap.empty) {
        return setError("Email domain unauthorized.");
      }
      // An SSO district's accounts are created on first district sign-in (the
      // beforeUserCreate blocking function seeds users/{uid}), never here.
      const districtProviderId = ssoProviderIdOf(querySnap, email);
      if (districtProviderId) {
        return setSsoProviderId(districtProviderId);
      } else {
        const userCredential = await createUserWithEmailAndPassword(
          projectAuth,
          email,
          password
        );
        querySnap.forEach((doc) => {
          if (doc.exists()) {
            return defaultSettings.push(doc.data());
          }
          return null;
        });
        await updateProfile(projectAuth.currentUser, {
          displayName: userCredential.user.displayName,
        });

        await setDoc(
          doc(db, "users", userCredential.user.uid),
          defaultSettings[1] && defaultSettings[1].matchType === "email"
            ? {
                uid: userCredential.user.uid,
                jobTitle: displayName,
                defaultConsortium: defaultSettings[1].assignConsortium,
                defaultDistrict: defaultSettings[1].assignDistrict,
                defaultWDA: defaultSettings[1].assignWDA,
                defaultLocalColleges: defaultSettings[1].assignColleges,
                defaultZip: defaultSettings[1].assignZip,
                defaultRadius: defaultSettings[1].assignRadius,
                defaultJobBoard: "IN",
                email: email,
                firstName: firstName,
                lastName: lastName,
              }
            : {
                uid: userCredential.user.uid,
                jobTitle: displayName,
                defaultConsortium: defaultSettings[0].assignConsortium,
                defaultDistrict: defaultSettings[0].assignDistrict,
                defaultWDA: defaultSettings[0].assignWDA,
                defaultLocalColleges: defaultSettings[0].assignColleges,
                defaultZip: defaultSettings[0].assignZip,
                defaultRadius: defaultSettings[0].assignRadius,
                defaultJobBoard: "IN",
                email: email,
                firstName: firstName,
                lastName: lastName,
              }
        );

        await sendEmailVerification(userCredential.user, actionCodeSettings);

        navigate("/success");

        // .then(() => {
        //   projectAuth.signOut()
        // })

        await projectAuth.signOut();

        // dispatch logout action
        dispatch({ type: "LOGOUT" });

        if (!isCancelled) {
          setIsPending(false);
          setError(null);
        }
      }
    } catch (error) {
      if (!isCancelled) {
        setError(error.code);
        setIsPending(false);
      }
    }
  };

  useEffect(() => {
    return () => setIsCancelled(true);
  }, []);

  return { signup, error, isPending, ssoProviderId, checkEmail };
};
